import { User } from 'firebase/app';
import { createContext } from 'react';

export const UserContext = createContext<{ user: User | null }>({ user: null });
